import type {
  DemandApiResponse,
  DemandErrorResponse,
  DemandFormData,
  DemandFormErrors,
  DemandFormField,
} from './types';

/**
 * Type predicate: `strictNullChecks` está desabilitado no tsconfig, e sem
 * ele o TypeScript não estreita união discriminada por booleano literal.
 */
export function isDemandFailure(
  response: DemandApiResponse
): response is DemandErrorResponse {
  return response.success === false;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';

const FIELDS: DemandFormField[] = [
  'full_name',
  'email',
  'company',
  'phone',
  'segment',
  'stores',
  'skus',
  'sales_history',
  'stock_control',
  'difficulty',
  'consent_accepted',
];

function extractFieldErrors(data: unknown): DemandFormErrors | undefined {
  if (!data || typeof data !== 'object') return undefined;

  const payload = data as Record<string, unknown>;
  const errors: DemandFormErrors = {};

  FIELDS.forEach((field) => {
    const value = payload[field];
    if (Array.isArray(value) && typeof value[0] === 'string') {
      errors[field] = value[0];
    } else if (typeof value === 'string') {
      errors[field] = value;
    }
  });

  return Object.keys(errors).length > 0 ? errors : undefined;
}

export async function requestDemandDiagnosis(
  input: DemandFormData
): Promise<DemandApiResponse> {
  try {
    const res = await fetch(`${API_BASE_URL}/leads/demand/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });

    if (res.ok) {
      return { success: true };
    }

    const data = await res.json().catch(() => null);

    return {
      success: false,
      code: 'VALIDATION_ERROR',
      message:
        'Não foi possível enviar a solicitação. Revise os campos destacados.',
      fieldErrors: extractFieldErrors(data),
    };
  } catch {
    return {
      success: false,
      code: 'NETWORK_ERROR',
      message:
        'Erro de conexão. Seus dados foram mantidos — verifique sua internet e tente novamente.',
    };
  }
}
